import { render, staticRenderFns } from "./smokecribdata.vue?vue&type=template&id=0ae6976d&scoped=true&"
import script from "./smokecribdata.vue?vue&type=script&lang=ts&"
export * from "./smokecribdata.vue?vue&type=script&lang=ts&"
import style0 from "./smokecribdata.vue?vue&type=style&index=0&id=0ae6976d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6976d",
  null
  
)

export default component.exports